module.exports = __webpack_public_path__ + "static/media/jenifferGif.d1f805aa.mp4";